export default __webpack_public_path__ + "guide--imagery-4up-960-a1f61d51d54da37393580d4b60b4e0ec.webp";